import { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core';
import { autoPlayBetStore, gameStore, inputValidationStore } from '../../../../store';
import { handlePlusMinusValue } from '../../../../helpers';
import { BaseBetAmount, AutoCashOut } from '../../../../components/common/bettingPart';
import { minOddConst } from '../../../../enums/gameConstants';
import { useAmountValidation } from '../../../../helpers';
import { GameResponseTypeName } from '../../../../enums';
import { checkMaxAutoCashOutValue } from '../../../../helpers/checkMaxAutoCashOutValue';

export const BetAmountAutoCashOutWr = observer(({ t, limits, handleOpenNumPad }) => {
  const { autoCashOutOdd, baseBetAmount } = autoPlayBetStore.autoPlayData;
  const { minOdd } = gameStore;
  const { activeFreeBet } = freeBetStore;

  const autoPlayAmountParams = {
    storeValue: baseBetAmount,
    minValue: limits.minBet,
    maxValue: limits.maxBet,
    incDec: limits.minBet,
  };

  const autoPlayCashOutParams = {
    storeValue: autoCashOutOdd,
    minValue: activeFreeBet?.minOdd || minOdd,
    maxValue: checkMaxAutoCashOutValue(baseBetAmount, limits.maxWin),
    incDec: 0.1,
  };

  useEffect(() => {
    const maxAutoCashOutValue = checkMaxAutoCashOutValue(baseBetAmount, limits.maxWin);
    if (autoCashOutOdd > maxAutoCashOutValue && baseBetAmount <= limits.maxBet) {
      const maxValue = maxAutoCashOutValue > minOddConst ? maxAutoCashOutValue : minOddConst;
      autoPlayCashOutParams.maxValue = maxValue;
      autoPlayBetStore.setAutoCashOutValue(maxValue);
    }
    // sendStakeUpdate(baseBetAmount, true);
  }, [baseBetAmount]);

  const handleChangeAutoCashOut = useCallback((changeValue) => {
    autoPlayBetStore.setAutoCashOutValue(changeValue);
  }, []);

  const { simpleOnChange: onChangeAutoCashOut } = useAmountValidation(handleChangeAutoCashOut);

  const handleChangeBaseBate = useCallback((changeValue) => {
    autoPlayBetStore.setBaseBetAmountValue(changeValue);
  }, []);

  const { simpleOnChange: onChangeBaseBate } = useAmountValidation(handleChangeBaseBate);

  const handleAutoCashOutOdd = useCallback(
    (actionType) => {
      const changedOddValue = handlePlusMinusValue(actionType, autoPlayCashOutParams);
      autoPlayBetStore.setAutoCashOutValue(+changedOddValue.toFixed(2));
    },
    [autoCashOutOdd, autoPlayCashOutParams.maxValue]
  );
  const autoCashOutOnBlur = (e) =>
    inputValidationStore.setDefaultValue(
      e.target?.value.trim(),
      autoPlayBetStore.setAutoCashOutValue,
      autoPlayCashOutParams,
      null,
      GameResponseTypeName.AutoCashOut
    );

  const handleBaseBetAmount = useCallback(
    (actionType) => {
      const changedOddValue = handlePlusMinusValue(actionType, autoPlayAmountParams);
      autoPlayBetStore.setBaseBetAmountValue(+changedOddValue.toFixed(2));
    },
    [baseBetAmount]
  );
  const baseBetOnBlur = (e) =>
    inputValidationStore.setDefaultValue(
      e.target?.value.trim(),
      autoPlayBetStore.setBaseBetAmountValue,
      autoPlayAmountParams,
      null,
      GameResponseTypeName.Bet
    );

  return (
    <div className='bet-sec-row'>
      <div className='bet-sec-col'>
        <BaseBetAmount
          handleBaseBetAmount={handleBaseBetAmount}
          onChangeBaseBate={onChangeBaseBate}
          onBlur={baseBetOnBlur}
          baseBetAmount={baseBetAmount}
          handleOpenNumPad={handleOpenNumPad}
          autoPlayAmountParams={autoPlayAmountParams}
          t={t}
        />
        <AutoCashOut
          handleBaseBetAmount={handleBaseBetAmount}
          handleAutoCashOutOdd={handleAutoCashOutOdd}
          onChangeAutoCashOut={onChangeAutoCashOut}
          autoCashOutOdd={autoCashOutOdd}
          onBlur={autoCashOutOnBlur}
          autoPlayCashOutParams={autoPlayCashOutParams}
          handleOpenNumPad={handleOpenNumPad}
          t={t}
        />
      </div>
    </div>
  );
});
